export const capitalize = (value: string): string =>
  value[0].toUpperCase() + value.slice(1);

export const parseToInt = (value = ''): number | undefined =>
  value.length ? Number.parseInt(value) : undefined;

export const getOnlyNumbers = (value = ''): string =>
  value.replace(/[^0-9]/g, '');
